import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ComponentStatus } from 'bom/enums';
import { Button } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { IJobPart } from 'jobs/types';
import { Variant } from 'theme/enums';

import { CopyMoveToElement } from './CopyMoveToElement';

interface IProps {
  jobId: number;
}

export const CopyMoveToElementButton = ({ jobId }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { selectedRows, deselectAllRows } = useAgGridTableContext();

  const selectedActiveJobParts = useMemo(() => {
    return selectedRows.filter(
      (jobPart: IJobPart) => jobPart.status !== ComponentStatus.DELETED
    ) as IJobPart[];
  }, [selectedRows]);

  const isDisabled = useMemo(
    () =>
      selectedActiveJobParts.length === 0 ||
      selectedRows.some((jobPart: IJobPart) => jobPart.status === ComponentStatus.DELETED),
    [selectedActiveJobParts, selectedRows]
  );

  const onSubmitSuccess = () => deselectAllRows();

  return (
    <>
      <Button
        text={t('buttonLabelCopyMoveToElement')}
        variant={Variant.OUTLINED}
        onClick={() => setIsOpen(true)}
        disabled={isDisabled}
      />

      {!isDisabled && (
        <CopyMoveToElement
          jobId={jobId}
          bomParts={selectedRows}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onSubmitSuccess={onSubmitSuccess}
        />
      )}
    </>
  );
};
